import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/AuthContext'
import { startAppTour, isAppTourCompleted } from '../utils/appTour'

/**
 * 掛在主要版面內：依「是否第一次開通」自動顯示系統教學。
 * - 用後端 onboardingCompleted === false 表示新開通店家；
 * - 用 localStorage 記錄是否已看過教學，看過就不再自動顯示。
 * - 「重新觀看系統教學」按鈕仍可手動觸發 tour。
 */
export default function AppTourLauncher() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const hasLaunched = useRef(false)

  useEffect(() => {
    if (!user || hasLaunched.current) return
    // 僅在「後端明確回傳已開通」時不自動顯示；未回傳或 false 都視為新店家，進入首頁就啟動教學
    const alreadyOnboarded = user.onboardingCompleted === true
    if (alreadyOnboarded || isAppTourCompleted()) return

    // 延遲啟動，確保 Sidebar / 選單已掛載；標記放在 callback 內，避免 React Strict Mode 下 cleanup 取消 timeout 後不再觸發
    const t = setTimeout(() => {
      if (hasLaunched.current) return
      hasLaunched.current = true
      startAppTour(navigate, 0, user?.businessId, user?.userId)
    }, 400)
    return () => clearTimeout(t)
  }, [user, navigate])

  return null
}
